module.exports = __webpack_public_path__ + "assets/icona_navetta_luogo.c89e7b3a.svg";